import { TokenParams } from '@shared/types/token-params';

export function getTokenParams(): TokenParams {
  const url = new URL(window.location.href);
  const queryParams = new URLSearchParams(url.search);
  return {
    token: queryParams.get('token') ?? '',
    instance: queryParams.get('instance') ?? '',
    gameUuid: queryParams.get('gameUuid') ?? '',
    isFromHub: queryParams.get('hub') === 'true',
    hubGameUuid: queryParams.get('hubGameUuid') ?? '',
    language: queryParams.get('language') ?? '',
    bg: queryParams.get('bg') ?? '',
  };
}
